var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('header',[_c('Header')],1),_c('main',{staticClass:"content"},[(_vm.$route.path.includes('/system'))?_c('aside',{ref:"aside"},[_c('Aside',{attrs:{"side-list":_vm.leftNav}})],1):_vm._e(),_c('router-view',{staticClass:"main_content"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }